import dayjs from 'dayjs'

export const YEAR_OPTIONS = Array.from({ length: 130 }, (_, i) => ({
  value: String(2030 - i),
  label: String(2030 - i),
}))

export const MONTH_OPTIONS = Array.from({ length: 12 }, (_, i) => ({
  value: `${i}`,
  label: dayjs().month(i).format('MMM'),
}))
